import { Component, inject } from '@angular/core';
import { IconComponent } from '@app2/shared/components/icon/icon.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { userSelectors } from '@store/user';
import { Store } from '@ngrx/store';
import { fapsActions } from '@app2/store/faps/faps.actions';
import { SearchComponent } from '@app2/features/search/search.component';
import { DialogService } from 'primeng/dynamicdialog';
import { OverlayService } from '@app/services/dialog/overlay.service';

@Component({
  selector: 'sens-bottom-bar',
  imports: [
    IconComponent,
    RouterLinkActive,
    RouterLink,
  ],
  templateUrl: './bottom-bar.component.html',
  styleUrl: './bottom-bar.component.scss',
  standalone: true,
})
export class BottomBarComponent {
  private readonly store = inject(Store);

  private readonly dialogService = inject(DialogService);

  private readonly overlayService = inject(OverlayService);

  user = this.store.selectSignal(userSelectors.selectUserData);

  onOpenFeed(): void {
    this.store.dispatch(fapsActions.loadFeed({ p: 1, reload: true }));
  }

  openSearch(): void {
    // this.overlayService.openComponent(SearchComponent);
    this.dialogService.open(SearchComponent, {
      maskStyleClass: 'fullscreen-mask',
      header: undefined,
      showHeader: false,
      modal: true,
      dismissableMask: true,
      transitionOptions: '.3s ease-in-out',
    });
  }
}
